import React, { useEffect, createElement } from 'react'
import { useConfig } from '@ynap/immutables-provider'
import BEMHelper from '@ynap/bem-helper'
import { IKlarnaValues } from './types'

const bem = new BEMHelper('KlarnaExpressButton')

type KlarnaValuesWithoutData = Omit<IKlarnaValues, 'setError' | 'config' | 'data'>

interface IProps extends KlarnaValuesWithoutData {
    theme?: string
    label?: string
    shape?: string
    className?: string
}

const KlarnaExpressButton = (props: IProps) => {
    const { className, locale, theme = 'default', shape = 'rect', label = 'default', setKlarnaExpress, history } = props
    const config = useConfig()
    const localeId = locale.id || 'en-GB'
    const [language, country] = localeId?.split('-')
    const availableLocale = config.head.klarna?.express?.availability?.includes(localeId.toLocaleLowerCase())
        ? `${language.toLowerCase()}-${country.toUpperCase()}`
        : 'en-GB'

    useEffect(() => {
        window.Klarna?.ExpressButton.refreshButtons()
        window.klarnaExpressButtonAsyncCallback = () => {
            window.Klarna?.ExpressButton.on('user-authenticated', (klarnaData) => {
                setKlarnaExpress({ values: klarnaData })
                history?.push(`/${locale.id}/checkout/login`)
            })
        }
    }, [])

    return (
        <div className={bem('wrapper')}>
            <>
                {createElement('klarna-express-button', {
                    'data-locale': availableLocale,
                    'data-theme': theme,
                    'data-shape': shape,
                    'data-label': label,
                    class: bem('expressButton', null, className),
                })}
            </>
        </div>
    )
}

export default KlarnaExpressButton
